import Vue from 'vue'
import qs from 'qs'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import '../static/css/theme-green/index.css';       // 浅绿色主题
import './assets/css/icon.css';
import './components/admin/common/directives';
import "babel-polyfill";
import tools from './components/admin/common/tool.js';
import {getToken, removeToken} from './components/admin/common/auth.js';
// import {Loading} from 'element-ui';
import 'default-passive-events';


Vue.config.productionTip = false
Vue.use(ElementUI, {
    size: 'small'
});

// axios.defaults.baseURL = process.env.VUE_APP_API_URL + ":" + process.env.VUE_APP_API_PORT;

Vue.prototype.$axios = axios;
Vue.prototype.$tools = tools;
Vue.prototype.$qs = qs;

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    // const role = localStorage.getItem('ms_username');
    // if (!role && to.path !== '/login') {
    //     next('/login');
    // } else if (to.meta.permission) {
    //     // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
    //     role === 'admin' ? next() : next('/403');
    // } else {
    // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
    if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
        Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
            confirmButtonText: '确定'
        }).finally();
    } else {
        next();
    }
    // }
})

/**
 * 全局拦截axios，
 * 登陆认证：后端shiro未登陆的话会返回401的error，拦截此报错并将path指向登陆页
 * 权限认证：后端shiro会返回-3的response，拦截此response并将path指向未授权页面
 * @param  {[type]} response) {                                                        return response;} [description]
 * @param  {[type]} function  (err)         {    if(err.response.status [description]
 * @return {[type]}           [description]
 */
Vue.prototype.$axios.interceptors.response.use(
    function (response) {
        if (response.data.code === -2) {
            router.replace({
                path: '/unAuthorized'
            }).finally()
        }
        return response;
    }, function (err) {

        if (!err || !err.response){
            router.replace({
                path: '/work/board'
            }).finally();
        }
        else if (err.response.status === 401 && err.response.data && err.response.data.path === '/workOriginator/createDataFill') {
            /*创建申请时直接弹出登录框*/
        }
        else if (err.response.status === 401) {
            removeToken();
            router.replace({
                path: '/work/login'
            }).finally();
            return Promise.reject("");
        } else if (err.response.status === 403 || err.response.status === 404){
            router.replace({
                path: '/work/board'
            }).finally();
            return Promise.reject("");
        }
        return Promise.reject(err);
    });

Vue.prototype.$axios.interceptors.request.use(config=>{
    const isToken = (config.headers || {}).isToken === false;
    if(!isToken && getToken()){
        config.headers['token'] = getToken();
        // config.headers['token'] = "eyJhbGciOiJIUzI1NiJ9.eyJhY2NvdW50IjoidW5pc19pdCIsImlkIjoiOTk5MzE2MjMwNDU0MTE2MzUyIiwicHdkIjoiVW5pczEyMzQ1NiIsInRpbWUiOjE2NTgzODY5MzA2MDh9.7ZGEMLilS-aig5ncbXFlkBZmUZQw9_7hqIm1hl-J5OI"
    }
    return config;
},error => {
    console.log(error);
    return Promise.reject(error);
})


new Vue({
    router,
    render: h => h(App)
}).$mount('#app')